import { normalizeName } from './import-topology-shared';

/** Higher score = prefer this interface when the same device would attach twice. */
export function scoreInterfaceForDeviceEdgeOrder(params: {
  portId: string;
  vlanIds: number[];
  intfNameTrimmed: string;
  inferredPeerName: string;
  untaggedVid: number | undefined;
}): number {
  const { portId, vlanIds, intfNameTrimmed, inferredPeerName, untaggedVid } =
    params;

  let s = 0;
  if (typeof untaggedVid === 'number') s += 50;
  if (vlanIds.length === 1) s += 35;
  if (vlanIds.length > 1 && vlanIds.length <= 8) s += 5;
  if (vlanIds.length > 8) s -= 35;
  if (/^G\d$/i.test(portId)) s -= 40;
  if (/^P\d$/i.test(portId)) s += 15;
  if (
    intfNameTrimmed &&
    normalizeName(intfNameTrimmed) === normalizeName(inferredPeerName)
  ) {
    s += 45;
  }
  return s;
}
